import moment from "moment";
import {
  getCityOptions,
  getMpPointOptions,
  getProvinceOptions
} from "../../utils/cityPickerOptions";
import {
  pickerOptions,
  pickerOptionsOfYear
} from "../../utils/datePickerOptions";
const state = {
  //地点选择
  cityOptions: [], //城市列表
  provinceOptions: [], //省份列表
  mpPointOptions: [], //国控站点列表
  mpProPointOptions: [], //省控站点列表

  pickerCity: ["天津市", "120000"], // [省份,城市],  用于级联选择
  pickerCodes: [],
  pickerMpCodes: [],
  pickerMpPoint: "1015A", //国控站点
  pickerMpProPoint: "", //省控站点
  pickerCityName: "天津市",
  pickerProvince: "河北省", // ‘省份名称’,  用于省份单选; map地图需要进行二次匹配转换为拼音
  pickerDayOrHour: "hour",

  //日期时间选择
  datePickerOptions: pickerOptions,
  datePickerOptionsOfYear: pickerOptionsOfYear,
  pickerDateOfYear: moment().format("YYYY"),
  pickerDateOfMonth: moment().format("YYYY-MM"),
  pickerDateOfTime: moment()
    .subtract(0, "h")
    .format("YYYY-MM-DD HH:mm:ss"),
  pickerDateRange: [
    moment()
      .subtract(7, "d")
      .format("YYYY-MM-DD"),
    moment()
      .subtract(1, "d")
      .format("YYYY-MM-DD")
  ],

  //其他
  seriesData: [],
  accrualRateSeriesData: []
};

const getters = {
  cityOptions: state => state.cityOptions,
  provinceOptions: state => state.provinceOptions,
  mpPointOptions: state => state.mpPointOptions,
  pickerProvince: state => state.pickerProvince,
  pickerCityName: state => state.pickerCityName,
  pickerCity: state => state.pickerCity,
  pickerCodes: state => state.pickerCodes,
  pickerMpCodes: state => state.pickerMpCodes,
  pickerMpPoint: state => state.pickerMpPoint,
  pickerDayOrHour: state => state.pickerDayOrHour,

  datePickerOptions: state => state.datePickerOptions,
  datePickerOptionsOfYear: state => state.datePickerOptionsOfYear,
  pickerDateOfYear: state => state.pickerDateOfYear,
  pickerDateOfMonth: state => state.pickerDateOfMonth,
  pickerDateOfTime: state => state.pickerDateOfTime,
  pickerDateRange: state => state.pickerDateRange
};
const mutations = {
  UPDATE_CITY_OPTIONS(state, newValue) {
    state.cityOptions = newValue;
  },
  UPDATE_MP_POINT_OPTIONS(state, newValue) {
    state.mpPointOptions = newValue;
  },

  UPDATE_PROVINCE_OPTIONS(state, newValue) {
    state.provinceOptions = newValue;
  },

  UPDATE_PICKER_CITY(state, newValue) {
    state.pickerCity = newValue;
  },
  UPDATE_PICKER_CODES(state, newValue) {
    state.pickerCodes = newValue;
  },
  UPDATE_PICKER_MP_CODES(state, newValue) {
    state.pickerMpCodes = newValue;
  },

  UPDATE_PICKER_CITYNAME(state, newValue) {
    state.pickerCityName = newValue;
  },

  UPDATE_PICKER_MP_POINT(state, newValue) {
    state.pickerMpPoint = newValue;
  },

  UPDATE_PICKER_MP_PRO_POINT(state, newValue) {
    state.pickerMpProPoint = newValue;
  },

  UPDATE_PICKER_PROVINCE(state, newValue) {
    state.pickerProvince = newValue;
  },

  UPDATE_PICKER_DAY_OR_HOUR(state, newValue) {
    state.pickerDayOrHour = newValue;
  },

  UPDATE_PICKER_DATERANGE(state, newValue) {
    state.pickerDateRange = newValue;
  },

  UPDATE_PICKER_YEAR(state, newValue) {
    state.pickerDateOfYear = newValue;
  },

  UPDATE_PICKER_MONTH(state, newValue) {
    state.pickerDateOfMonth = newValue;
  },

  UPDATE_PICKER_TIME(state, newValue) {
    state.pickerDateOfTime = newValue;
  },

  UPDATE_PICKER_SERIESDATA(state, newValue) {
    state.seriesData = newValue;
    // console.log("已更新,新值是:", newValue);
  }
};
const actions = {
  fetchCityOptions({ commit }) {
    getCityOptions().then(data => {
      commit("UPDATE_CITY_OPTIONS", data);
    });
  },

  fetchProvinceOptions({ commit }) {
    getProvinceOptions().then(data => {
      commit("UPDATE_PROVINCE_OPTIONS", data);
    });
  },

  async fetchMpPointOptions({ commit, state }, cityCode) {
    await getMpPointOptions(cityCode).then(data => {
      commit("UPDATE_MP_POINT_OPTIONS", data);
      commit("UPDATE_PICKER_MP_POINT", data[0].value);
      commit("UPDATE_PICKER_MP_CODES", []);
    });
  }
};

export default { state, actions, mutations, getters };



// WEBPACK FOOTER //
// ./src/store/modules/causeAnalyse.js